import { Mail, MessageSquareText, Send } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "@/api";
import { SmsCompose } from "@/components/steps/SmsCompose";
import { SmsInbox } from "@/components/steps/SmsInbox";
import InboxPage from "@/pages/InboxPage";

export default function RepliesPage() {
  const [channel, setChannel] = useState(() => (new URLSearchParams(window.location.search).get("canal") === "sms" ? "sms" : "email"));
  const [unread, setUnread] = useState(0);
  const [sms, setSms] = useState(false);
  useEffect(() => { api.get("/sms/threads").then(({ data }) => setUnread(data.reduce((n, t) => n + t.unread, 0))).catch(() => {}); }, [channel]);
  return (
    <>
      <div className="page rp-switch-wrap"><div className="rp-tools"><div className="rp-switch pj-seg" data-testid="replies-channel">
        <button type="button" className={channel === "email" ? "is-on" : ""} onClick={() => setChannel("email")} data-testid="replies-channel-email"><Mail size={15} />E-mails</button>
        <button type="button" className={channel === "sms" ? "is-on" : ""} onClick={() => setChannel("sms")} data-testid="replies-channel-sms"><MessageSquareText size={15} />SMS{unread > 0 && <span className="nav-badge" data-testid="replies-sms-unread">{unread}</span>}</button>
      </div>
      <button type="button" className="rp-sms-new" onClick={() => setSms(true)} data-testid="replies-new-sms"><Send size={15} />Envoyer un SMS à un numéro</button></div></div>
      <SmsCompose open={sms} onOpenChange={setSms} onSent={() => setChannel("sms")} />
      {channel === "email" ? <InboxPage /> : <SmsInbox onRead={() => setUnread(0)} />}
    </>
  );
}
